function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.243 4.97a.86.86 0 0 0 0-1.213.86.86 0 0 0-1.213 0L8 6.788 4.97 3.757a.86.86 0 0 0-1.213 0 .86.86 0 0 0 0 1.213L6.788 8l-3.031 3.03a.86.86 0 0 0 0 1.213.86.86 0 0 0 1.213 0L8 9.212l3.031 3.031a.858.858 0 0 0 1.212-1.213L9.212 8z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
export default SvgClose;